module.exports = __webpack_public_path__ + "static/media/logo_color.897126c9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/logo_color.svg
// module id = 739
// module chunks = 0